import { useEffect } from "react";
import switchTipoNodo from "../../utils/switchTipoNodo";
import { dateDiffInMinutes } from "../../utils/date";

const identificarIcono = (nodeData, tipoNodo, fechaUltimoDato, husoHorario) => {
    let icono = "";

    if (tipoNodo === "RF-X1") {
        icono = "x1";
        if (nodeData.is_gw) {
            icono = `${icono}-gw`;
        }
        if (nodeData.nivel_bateria_porcentaje <= 40) {
            icono = `${icono}-low`;
        }
        if (dateDiffInMinutes(fechaUltimoDato, husoHorario) >= 180) {
            icono = `${icono}-dis`;
        }
    }
    if (tipoNodo === "RF-V1-4Latch") {
        icono = "v1";
        if (nodeData.is_gw) {
            icono = `${icono}-gw`;
        }
        if (nodeData.nivel_bateria_porcentaje <= 40) {
            icono = `${icono}-low`;
        }
        if (dateDiffInMinutes(fechaUltimoDato, husoHorario) >= 180) {
            icono = `${icono}-dis`;
        }
    }
    if (tipoNodo === "RF-C1") {
        icono = "c1";
        if (nodeData.is_gw) {
            icono = `${icono}-gw`;
        }
        if (nodeData.nivel_bateria_porcentaje <= 40) {
            icono = `${icono}-low`;
        }
        if (dateDiffInMinutes(fechaUltimoDato, husoHorario) >= 180) {
            icono = `${icono}-dis`;
        }
    }

    if (tipoNodo === "RF-M1") {
        icono = "m1";
        if (nodeData.nivel_bateria_porcentaje <= 40) {
            icono = `${icono}-low`;
        }
        if (dateDiffInMinutes(fechaUltimoDato, husoHorario) >= 180) {
            icono = `${icono}-dis`;
        }
    }

    if (tipoNodo === "RF-M1-3G") {
        icono = "m1-3g";
        if (nodeData.nivel_bateria_porcentaje <= 40) {
            icono = `${icono}-low`;
        }
        if (dateDiffInMinutes(fechaUltimoDato, husoHorario) >= 180) {
            icono = `${icono}-dis`;
        }
    }
    return icono;
};

const NodeMarker = ({ childrenCommon, nodesCommon, nodo,
    editable, isHover, isSecondary, isTarget, husoHorario, iconBorder }) => {
    useEffect(() => {
        const { bounds, drawedElements, data, linkIcon, closeInfoWindow, openInfoWindow, farmId, gmap } = childrenCommon;
        const { nodesDict, nodes } = nodesCommon;
        const nodeData = nodesDict[nodo];
        if (!nodeData) return;

        const LatLng = new window.google.maps.LatLng(data.nodos[nodo].lat, data.nodos[nodo].lng);
        bounds.extend(LatLng);
        let icon;

        const tipoNodo = switchTipoNodo(nodeData.tipo);
        const urlName = tipoNodo && tipoNodo.split("-")[1].toLowerCase();

        const size = isHover ? 40 : (isSecondary ? 24 : 32);
        if (!urlName) {
            icon = {
                path: window.google.maps.SymbolPath.CIRCLE, fillColor: "blue",
                fillOpacity: 1, strokeColor: "black ", scale: (size / 5) >> 0
            };
        } else {
            icon = {
                url: iconBorder || isHover ?
                    `/markers/${identificarIcono(nodeData, tipoNodo, nodeData.fecha_ultimo_dato, husoHorario)}-white.png` :
                    isSecondary ? `/markers/black-border/${identificarIcono(nodeData, tipoNodo, nodeData.fecha_ultimo_dato, husoHorario)}-black.png` :
                        (!isTarget ? `/markers/black-border/${identificarIcono(nodeData, tipoNodo, nodeData.fecha_ultimo_dato, husoHorario)}-black.png` :
                            `/markers/${identificarIcono(nodeData, tipoNodo, nodeData.fecha_ultimo_dato, husoHorario)}-white.png`),
                scaledSize: new window.google.maps.Size(size, size),
                anchor: new window.google.maps.Point(size / 2, size)
            };
        }

        const marker = new window.google.maps.Marker({
            draggable: editable,
            position: LatLng,
            icon,
            map: gmap
        });
        if (isTarget) {
            drawedElements.current[0] && drawedElements.current[0].setMap(null);
            drawedElements.current[0] = marker;
        } else {
            nodes.current[nodo] = marker;
        }

        const { nombre: nodoName, parent } = nodeData;

        let gwAnd3g = false;
        if (nodesDict) {
            const cantGws = Object.values(nodesDict).filter(n => n.has_modem);
            if (cantGws.length >= 2) {
                gwAnd3g = true;
            }
        }

        if (editable) {
            marker.addListener("click", () => {
                // we do get "t" here to get the updated one
                const innerT = childrenCommon.t;
                closeInfoWindow();
                openInfoWindow(
                    gmap,
                    `<button type="button" class="btn btn-link" id="clickListener">${innerT("maps.delete")}</button>`,
                    marker.getPosition(),
                    () => {
                        marker.setMap(null);
                        const index = drawedElements.current.indexOf(marker);
                        if (index > -1) {
                            drawedElements.current.splice(index, 1);
                        }
                        closeInfoWindow();
                    }
                );
            }, { passive: true });
        } else {
            const tipoLabel = tipoNodo && (!nodeData.is_gw ? tipoNodo : `${tipoNodo} Gateway`);
            marker.addListener("click", () => {
                closeInfoWindow();
                if (childrenCommon.edit) return;
                openInfoWindow(
                    gmap,
                    `<div>${nodoName ? `<b>${nodoName}</b></br>` : ""
                    }${tipoLabel ? `${tipoLabel}</br>` : ""
                    }<button type="button" class="btn btn-link m-0 ${isTarget ? "d-none" : "d-block"}" id="clickListener" style="line-height:1.5em;">${linkIcon
                    }</button></div>`,
                    marker.getPosition(),
                    () => childrenCommon.navigate(
                        { pathname: "/farms/node", search: `?farm=${farmId}&node=${nodo}` },
                        {
                            state: {
                                expanded: (typeof parent === "number" && gwAnd3g) ? ["network",`nodo-${parent}`,`nodo-${nodo}`] : ["network",`nodo-${nodo}`],
                                updateTree: true
                            }
                        }
                    )
                );
            }, { passive: true });
        }

        return () => {
            marker.setMap(null);
            const index = drawedElements.current.indexOf(marker);
            if (index > -1) {
                drawedElements.current.splice(index, 1);
            }

            if (nodes.current[nodo] === marker) delete nodes.current[nodo];
        };
    }, [nodo, childrenCommon, nodesCommon, editable, isHover, isSecondary, isTarget]);

    return null;
};

const UnasignedMarker = ({ childrenCommon, dataNode, isHover }) => {
    useEffect(() => {
        const { alternateView, bounds, drawedElements, data, linkIcon,
            closeInfoWindow, openInfoWindow, farmId, gmap } = childrenCommon;

        const size = isHover ? 40 : 32;

        const LatLng = new window.google.maps.LatLng(dataNode.path.lat, dataNode.path.lng);
        bounds.extend(LatLng);
        const icon = {
            path: window.google.maps.SymbolPath.CIRCLE, fillColor: isHover ? "red" : "blue",
            fillOpacity: 1, strokeColor: "black ", scale: (size / 5) >> 0
        };
        const marker = new window.google.maps.Marker({
            draggable: false,
            position: LatLng,
            icon,
            map: gmap
        });

        marker.addListener("click", (event) => {
            const { t: innerT, lngs, edit, navigate } = childrenCommon;
            closeInfoWindow();
            const content = `<div>${dataNode?.nombre ? `<b>${dataNode?.nombre}</b></br>` : ""}</div > `;

            openInfoWindow(
                gmap,
                content,
                marker.getPosition(),
            );
        }, { passive: true });

        return () => {
            marker.setMap(null);
            const index = drawedElements.current.indexOf(marker);
            if (index > -1) {
                drawedElements.current.splice(index, 1);
            }
        };

    }, [childrenCommon, dataNode, isHover]);

    return null;
};

export { NodeMarker, UnasignedMarker };
